import React from "react";

import {
  Container,
  ContentWrapper,
  Line,
  Subtitle,
  TextWrapper,
  Title,
  WrapperLeft,
  WrapperLink,
  WrapperRight,
} from "./styles";

import { ReactComponent as ArrowRight } from "../../assets/LParrowRight.svg";

const SectionCountWithStric: React.FC = () => {
  return (
    <Container>
      <ContentWrapper>
        <WrapperLeft>
          <Title>Conte com a Stric</Title>
          <Subtitle>Fuja das taxas dos Bancos!</Subtitle>
        </WrapperLeft>
        <WrapperRight>
          <TextWrapper>
            <Line />

            <div>
              <Title>Abra sua conta agora mesmo</Title>
              <Subtitle>
                É rápido e fácil: cadastre-se em menos de 10 minutos!
              </Subtitle>
            </div>
          </TextWrapper>
          <WrapperLink href="https://bank.stric.com.br/type-create-account">
            <strong>Abrir conta</strong>
            <ArrowRight />
          </WrapperLink>
        </WrapperRight>
      </ContentWrapper>
    </Container>
  );
};

export default SectionCountWithStric;
